<template>
  <!-- 待确认邮寄页面 -->
  <div class="box">
    <!-- 搜索部分 -->
    <div style="display: flex; margin-bottom: 35px">
      <div class="condition-item">
        <label class="fn-14">任务名称</label>
        <el-input
          clearable
          v-model="searchBatchName"
          placeholder="请输入任务名称"
          autocomplete="off"
          size="small"
          style="width: 160px"
        ></el-input>
      </div>
      <div class="condition-item">
        <label class="fn-14">摄影师</label>
        <el-input
          clearable
          v-model="searchPhotographer"
          placeholder="请输入摄影师"
          autocomplete="off"
          size="small"
          style="width: 160px"
        ></el-input>
      </div>
      <div class="condition-item">
        <label class="fn-14">创建时间</label>
        <el-date-picker
          clearable
          v-model="searchBeginTime"
          align="right"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择开始日期"
          autocomplete="off"
          size="small"
          style="width: 160px"
        >
        </el-date-picker>
        <label class="fn-14" style="padding: 0 10px">-</label>
        <el-date-picker
          clearable
          align="right"
          type="date"
          v-model="searchEndTime"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择结束日期"
          autocomplete="off"
          size="small"
          style="width: 160px"
        >
        </el-date-picker>
      </div>
      <div class="condition-item">
        <el-button
          type="primary"
          v-if="searchButton"
          size="small"
          style="width: 85px"
          @click="searchList"
          >搜 索</el-button
        >
      </div>
    </div>
    <!-- 列表盒子 -->
    <div
      style="display: flex; flex-direction: column; height: calc(100vh - 360px)"
    >
      <el-table
        border
        ref="multipleTable"
        :data="tobeconfirmedList"
        style="width: 100%; text-align: center"
        height="100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
        @selection-change="handleSelection"
      >
        <el-table-column align="center" fixed type="selection" width="50">
        </el-table-column>
        <el-table-column prop="title" fixed label="任务名称" width="300">
        </el-table-column>
        <el-table-column
          align="center"
          prop="senderName"
          label="联系人"
          width="120"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="联系人电话"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span></template
          >
        </el-table-column>

        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
          width="180"
        >
          <template slot-scope="scope">
            {{ formDateFormat(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="photographer"
          label="摄影师"
          width="120"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="totalCount"
          label="采集人数"
          width="120"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="mailGroup"
          label="邮寄分组"
          width="150"
        >
          <template slot-scope="scope">
            <span v-html="scope.row.mailGroup"></span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="mailCount"
          label="邮寄数"
          width="100"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="mailStatus"
          label="邮寄状态"
          width="120"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.mailStatus === 1"
              type="warning"
              effect="plain"
              size="small"
              >待生成邮寄单号</el-tag
            >
            <el-tag
              v-else-if="scope.row.mailStatus === 2"
              type="primary"
              effect="plain"
              size="small"
              >正在生成邮寄单号
            </el-tag>
            <el-tag
              v-else-if="scope.row.mailStatus === 3"
              type="warning"
              effect="plain"
              size="warning"
              >待打印面单</el-tag
            >
            <el-tag
              v-else-if="scope.row.mailStatus === 4"
              type="warning"
              effect="plain"
              size="small"
              >待确认邮寄</el-tag
            >

            <el-tag
              v-else-if="scope.row.mailStatus === 5"
              type="primary"
              effect="plain"
              size="small"
              >正在提交邮寄</el-tag
            >
            <el-tag
              v-else-if="scope.row.mailStatus === 6"
              type="success"
              effect="plain"
              size="small"
              >已邮寄</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="address" label="地址" width="540">
        </el-table-column>

        <el-table-column align="center" label="操作" width="280">
          <template slot-scope="scope">
            <el-button
              class="d-btn"
              type="primary"
              v-if="viewdetailsButton"
              @click="viewdetails(scope.row)"
              >查看明细</el-button
            >
            <el-button
              class="d-btn"
              type="primary"
              plain
              v-if="printOrderButton"
              @click.stop="printOrder(scope.row)"
              >打印面单</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="display: flex; justify-content: center; padding: 10px 0px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        style="display: flex; justify-content: center; flex-direction: row"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 查看明细弹窗 -->
    <div>
      <el-dialog
        title="查看明细"
        :visible.sync="showdetailed"
        width="1500px"
        class="ERER"
      >
        <!-- 搜索部分 -->
        <div style="display: flex; margin-bottom: 20px">
          <div class="condition-item">
            <label class="fn-14">拍照序号</label>
            <el-input
              clearable
              v-model="viewdetailSearch.searchIndexNumber"
              placeholder="请输入拍照序号"
              autocomplete="off"
              size="small"
            ></el-input>
          </div>
          <div class="condition-item">
            <label class="fn-14">姓名</label>
            <el-input
              clearable
              v-model="viewdetailSearch.searchIdName"
              placeholder="请输入姓名"
              autocomplete="off"
              size="small"
            ></el-input>
          </div>
          <div class="condition-item">
            <label class="fn-14">身份证号</label>
            <el-input
              clearable
              v-model.trim="viewdetailSearch.searchIdNumber"
              placeholder="请输入身份证号"
              autocomplete="off"
              size="small"
              width="220"
            ></el-input>
          </div>
          <div class="condition-item">
            <el-button
              type="primary"
              size="small"
              stylnae="width: 85px"
              @click="searchquery"
              >查询</el-button
            >
          </div>
        </div>
        <!-- 弹窗列表盒子 -->
        <div>
          <el-table
            border
            ref="multipleTable"
            :data="viewList"
            style="width: 100%; text-align: center"
            height="400"
            :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
          >
            <el-table-column
              align="center"
              prop="batchIndex"
              label="拍照序号"
              width="80"
              fixed
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="mailGroup"
              label="邮寄分组"
              width="150"
              fixed
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="idNumber"
              label="身份证号"
              width="240"
            >
              <template slot-scope="scope">
                <span>{{
                  execDecrypt(scope.row.idNumber, "Idcard")
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="姓名"
              width="120"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span></template
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="collectedTime"
              label="采集时间"
              width="240"
            >
              <template slot-scope="scope">
                {{ formDateFormat(scope.row.collectedTime) }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="schoolName"
              label="学校"
              width="220"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="mailNo"
              label="快递单号"
              width="220"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="mailStatus"
              label="操作"
              width="160"
            >
              <template slot-scope="scope">
                <el-button
                  class="d-btn"
                  type="primary"
                  plain
                  @click="printOrderOned(scope.row.orderNo)"
                  >打印面单</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="display: flex; justify-content: center; padding-top: 15px">
          <el-pagination
            @size-change="handleSizeChangeview"
            @current-change="handleCurrentChangeview"
            :current-page="currentPageView"
            style="display: flex; justify-content: center; flex-direction: row"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="pageSizeView"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalView"
          >
          </el-pagination>
        </div>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="showdetailed = false">取 消</el-button> -->
          <el-button type="primary" @click="showdetailed = false"
            >关 闭</el-button
          >
        </div>
      </el-dialog>

      <!-- 批次打印弹窗 -->
      <el-dialog
        title="邮寄订单打印预览"
        :visible.sync="printShow"
        width="400px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="print-view">
          <div id="printTestAll">
            <template v-for="item in PrintList">
              <div class="print-list" :key="item.id">
                <div class="mg-bottom-300">
                  <!-- 条行码 -->
                  <table class="print_paper table_first">
                    <tbody :data="PrintList">
                      <tr>
                        <td align="center" style="padding-top: 10px">
                          <vue-barcode
                            :value="item.mailNo"
                            :displayValue="false"
                            :height="40"
                            :width="1.4"
                            :margin="0"
                          >
                            {{ item.mailNo }}
                          </vue-barcode>
                          {{ item.mailNo }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 条行码 -->
                  <!-- 收方信息 -->
                  <table class="print_paper">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <div>
                            收方: {{ item.name }} {{ item.mobile }}<br />
                            {{ item.regionProvince }}{{ item.regionCity
                            }}{{ item.regionCounty }}{{ item.address }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 收方信息 -->
                  <!-- 寄方信息 -->
                  <table class="print_paper">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <div>
                            寄方: {{ item.senderName }} {{ item.senderMobile
                            }}<br />
                            {{ item.senderAddress }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="print_paper">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <div style="font-size: 14px; font-weight: bold">
                            拍摄批次：{{ item.batch }}<br />拍摄序号：{{
                              item.batchIndex || ""
                            }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 寄方信息 -->
                  <!-- 重量信息 -->
                  <table class="print_paper">
                    <tbody>
                      <tr>
                        <td width="45%">
                          付款方式：<br />
                          计费重量(KG)：<br />
                          保价金额(元)：
                          <div style="display: none">代收金额:</div>
                        </td>
                        <td>
                          收件人\代收人：<br />
                          签收时间：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;日
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 重量信息 -->
                  <!-- 备注 -->
                  <table class="print_paper">
                    <tbody>
                      <tr>
                        <td width="45%">备注：如无法投递,请与寄件方联系</td>
                        <td rowspan="2" align="center" width="100">
                          <img
                            class="logo"
                            height="70"
                            src="data:image/png;base64,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"
                            alt=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="120">
                          网址：www.ems.com.cn <br />客服电话：11183
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 备注 -->
                </div>
              </div>
              <div
                :key="item.id"
                style="
                  page-break-after: always;
                  height: 15px;
                  line-height: 15px;
                "
              ></div>
            </template>
          </div>
        </div>
        <div style="padding-top: 15px; text-align: center">
          <el-button type="primary" size="small" v-print="'#printTestAll'"
            >打印电子面单</el-button
          >
        </div>
      </el-dialog>
      <!-- 明细打印弹窗 -->
      <el-dialog
        title="邮寄订单打印预览"
        :visible.sync="printShowOne"
        width="400px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="print-view">
          <div id="printTestFirst">
            <template>
              <div class="print-list">
                <div class="mg-bottom-300">
                  <!-- 条行码 -->
                  <table class="print_paper table_first">
                    <tbody :data="PrintListOne">
                      <tr>
                        <td align="center" style="padding-top: 10px">
                          <vue-barcode
                            :value="PrintListOne.mailNo"
                            :displayValue="false"
                            :height="40"
                            :width="1.4"
                            :margin="0"
                          >
                            {{ PrintListOne.mailNo }}
                          </vue-barcode>
                          {{ PrintListOne.mailNo }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 条行码 -->
                  <!-- 收方信息 -->
                  <table class="print_paper">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <div>
                            收方: {{ PrintListOne.name }}
                            {{ PrintListOne.mobile }}<br />
                            {{ PrintListOne.regionProvince
                            }}{{ PrintListOne.regionCity
                            }}{{ PrintListOne.regionCounty
                            }}{{ PrintListOne.address }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 收方信息 -->
                  <!-- 寄方信息 -->
                  <table class="print_paper">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <div>
                            寄方: {{ PrintListOne.senderName }}
                            {{ PrintListOne.senderMobile }}<br />
                            {{ PrintListOne.senderAddress }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="print_paper">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <div style="font-size: 14px; font-weight: bold">
                            拍摄批次：{{ PrintListOne.batch }}<br />拍摄序号：{{
                              PrintListOne.batchIndex || ""
                            }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 寄方信息 -->
                  <!-- 重量信息 -->
                  <table class="print_paper">
                    <tbody>
                      <tr>
                        <td width="45%">
                          付款方式：<br />
                          计费重量(KG)：<br />
                          保价金额(元)：
                          <div style="display: none">代收金额:</div>
                        </td>
                        <td>
                          收件人\代收人：<br />
                          签收时间：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;日
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 重量信息 -->
                  <!-- 备注 -->
                  <table class="print_paper">
                    <tbody>
                      <tr>
                        <td width="45%">备注：如无法投递,请与寄件方联系</td>
                        <td rowspan="2" align="center" width="100">
                          <img
                            class="logo"
                            height="70"
                            src="data:image/png;base64,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"
                            alt=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="120">
                          网址：www.ems.com.cn <br />客服电话：11183
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 备注 -->
                </div>
              </div>
              <div
                style="
                  page-break-after: always;
                  height: 15px;
                  line-height: 15px;
                "
              ></div>
            </template>
          </div>
        </div>
        <div style="padding-top: 15px; text-align: center">
          <el-button type="primary" size="small" v-print="'#printTestFirst'"
            >打印电子面单</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 底部盒子 -->
    <div class="foolter">
      <div class="info-box">
        合计:<span class="number">{{ numberPeople }}人</span>
      </div>
      <el-button
        class="push"
        type="primary"
        v-if="mailingButton"
        @click="confirmMailing"
        :loading="confirming"
        >确认邮寄</el-button
      >
    </div>
  </div>
</template>
<script>
import {
  toConfirmListr,
  toConfirmListInfo,
  mailPrintOrder,
  printOrderOne,
  confirm,
} from "@/api/mail";
import { dateFormat } from "@/utils/date";
import VueBarcode from "vue-barcode";
import { formatPh, formatName, formatIdCard } from "@/utils/validate";
import { queryPageButton } from "@/api/permission";

export default {
  name: "tobeconfirmed",
  components: {
    VueBarcode,
  },
  data() {
    return {
      // 列表
      showdetailed: false,
      tobeconfirmedList: [], //列表数据
      numberPeople: 0,
      tableSelection: [],
      printShow: false, //邮寄订单预览
      searchPhotographer: "",
      searchBatchName: "",
      searchBeginTime: null,
      searchEndTime: null,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      PrintList: [], //打印数据
      // 明细
      viewList: [],
      viewdetailSearch: {
        searchIndexNumber: "",
        searchIdNumber: "",
        searchIdName: "",
      },
      PrintListOne: [], //快递信息
      currentPageView: 1,
      pageSizeView: 20,
      totalView: 0,
      id: 0,
      printOrderOneID: 0,
      printShowOne: false,
      confirming: false,
      printLoading: null,
      collectType: null,

      //权限按钮
      searchButton: false,
      viewdetailsButton: false,
      printOrderButton: false,
      mailingButton: false,
    };
  },
  created() {
    this.queryList();
    this.queryButton();
  },

  methods: {
    queryButton() {
      const data = 124;
      queryPageButton(data).then((resp) => {
        // console.log(resp);
        for (const button of resp.data) {
          if (button.code === "search") {
            this.searchButton = true;
          }
          if (button.code === "viewdetailsButton") {
            this.viewdetailsButton = true;
          }
          if (button.code === "printOrderButton") {
            this.printOrderButton = true;
          }
          if (button.code === "mailingButton") {
            this.mailingButton = true;
          }
        }
      });
    },
    /**
     * 时间格式化
     *
     * **/
    formDateFormat(dateValue) {
      if (dateValue != null) {
        return dateFormat("YYYY-mm-dd", new Date(dateValue));
      }
    },
    // 选择
    handleSelection(val) {
      this.tableSelection = val;
      let num = 0;
      this.tableSelection
        .filter((item) => item.totalCount)
        .forEach((item) => {
          num += item.totalCount;
        });
      if (num == 0) {
        this.numberPeople = 0;
      } else {
        this.numberPeople = num;
      }
    },
    queryList() {
      // 搜索条件
      const datas = {
        photographer: this.searchPhotographer,
        batchName: this.searchBatchName,
        beginTime: this.formDateFormat(this.searchBeginTime),
        endTime: this.formDateFormat(this.searchEndTime),
      };
      // 列表数据

      toConfirmListr(datas, this.currentPage, this.pageSize).then((resp) => {
        // console.log( resp);
        if (resp.code == 0) {
          let datas = resp.data.content;
          this.tobeconfirmedList = datas;
          this.total = resp.data.totalElements;
        }
      });
    },
    // 搜索
    searchList() {
      this.currentPage = 1;
      this.queryList();
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryList();
    },
    // 确认邮寄
    confirmMailing() {
      let json = JSON.parse(JSON.stringify(this.tableSelection));
      let maliList = {};
      let postdata = [];
      json.map((item) => {
        maliList = {
          id: item.id,
          collectType: item.collectType,
        };
        postdata.push(maliList);
      });

      if (!postdata.length) {
        this.$notify({
          title: "警告",
          message: "选择的任务不能为空",
          type: "warning",
        });
      } else {
        // console.log(postdata);
        this.confirming = true;
        confirm(postdata).then((resp) => {
          if (resp.code == 0) {
            this.$notify({
              title: "温馨提示",
              message: resp.message,
              type: "success",
            });
          } else {
            this.$notify({
              title: "警告",
              message: resp.message,
              type: "warning",
            });
          }
          this.confirming = false;
          this.queryList();
          this.numberPeople = 0;
        });
      }
    },

    // 查看明细
    viewdetails(data) {
      this.detailedID = data.id;
      this.collectType = data.collectType;
      this.viewdetailSearch = {};
      this.viewList = [];
      this.viewdetailsList();
    },
    // 明细列表
    viewdetailsList() {
      const postData = {
        id: this.detailedID,
        collectType: this.collectType,
        batchIndex: this.viewdetailSearch.searchIndexNumber,
        idNumber: this.viewdetailSearch.searchIdNumber,
        name: this.viewdetailSearch.searchIdName,
      };

      toConfirmListInfo(postData, this.currentPageView, this.pageSizeView).then(
        (resp) => {
          if (resp.code == 0) {
            // console.log(resp);
            this.viewList = resp.data.content;
            this.totalView = resp.data.totalElements;
            this.showdetailed = true;
          }
        }
      );
    },
    // 查看明细列表分页
    handleSizeChangeview(val) {
      this.pageSizeView = val;
      this.viewdetailsList();
    },
    handleCurrentChangeview(val) {
      this.currentPageView = val;
      this.viewdetailsList();
    },

    // 弹窗查询
    searchquery() {
      this.currentPageView = 1;
      this.viewdetailsList();
    },
    /**
     *  明细打印订单信息
     */
    printOrderOned(orderNo) {
      this.PrintListOne = [];
      this.printOrderOneID = orderNo;
      printOrderOne(this.printOrderOneID).then((resp) => {
        console.log(this.printOrderOneID);
        if (resp.code == 0) {
          this.$notify({
            title: "温馨提示",
            message: resp.message,
            type: "success",
          });

          this.PrintListOne = resp.data;
          console.log(this.PrintListOne);
          this.printShowOne = true;
          //   //  this.queryList();
        }
      });
    },
    /**
     *  批次打印订单信息
     */
    printOrder(data) {
      const postData = {};
      let mailArr = [];
      this.PrintList = [];
      // this.printLoading = true;
      this.printLoading = this.$loading({
        lock: true,
        text: "正在打印中....",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      mailArr = [
        {
          id: data.id,
          collectType: data.collectType,
        },
      ];
      postData.mailStatus = "3";
      postData.mailDtoList = mailArr;
      // console.log(postData);
      mailPrintOrder(postData).then((resp) => {
        if (resp.code == 0) {
          this.$notify({
            title: "温馨提示",
            message: resp.message,
            type: "success",
          });
          this.PrintList = resp.data;
          this.printLoading.close();
          this.printShow = true;
          this.queryList();
        } else {
          this.printLoading.close();
          this.queryList();
        }
      });
    },
    // 姓名、手机号脱敏
    execDecrypt(str, mod) {
      if (!str) {
        return str;
      } else if (mod == "ph") {
        return formatPh(str);
      } else if (mod == "name") {
        return formatName(str);
      } else if (mod == "Idcard") {
        return formatIdCard(str);
      }
    },
  },
};
</script>

<style scoped>
.el-checkbox__inner {
  border-radius: 20px !important;
}
/* 查看按钮 */
.d-btn {
  margin: 0px 10px;
  padding: 0px;
  width: 80px;
  height: 30px;
  text-align: center !important;
  line-height: 5px;
}
/* 列表盒子 */
.box div.plan-box {
  margin: 10px;
}
/* 合计人数 */
.box div.foolter {
  display: flex;
  justify-content: right;
  align-items: center;
  width: 100%;
  height: 40px;
  background: #f5f7fa;
}
.box div.foolter div.info-box span.number {
  padding: 0px 15px;
  color: #666;
}
.box div.foolter div.info-box span.number {
  padding: 0px 20px;
  color: #446cf3;
  font-size: 18px;
}
</style>
